exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1J9mbVsbRyVDVP{display:block;color:#5e6c84;text-align:center;font-size:12px;margin:10px 6px}", ""]);

// exports
exports.locals = {
	"feedback": "_1J9mbVsbRyVDVP"
};